import addNewProjectToGarageQuery from '../../GraphQL/CustomerProject/addNewProjectToGarage'
import getCustomerProjectsQuery from '../../GraphQL/CustomerProject/getCustomerProjects'
import removeProjectFromGarageQuery from '../../GraphQL/CustomerProject/removeProjectFromGarage'
import updateCustomerProjectQuery from '../../GraphQL/CustomerProject/updateCustomerProject'
import buildLinkQuery from '../../GraphQL/Traits/buildLink'
import getAllMakesQuery from '../../GraphQL/Traits/getAllMakes'
import getEngineDropdownQuery from '../../GraphQL/Traits/getEngineDropdown'
import getModelsQuery from '../../GraphQL/Traits/getModels'
import getRaceTypeDropdownQuery from '../../GraphQL/Traits/getRaceTypeDropdown'
import getYmmQuery from '../../GraphQL/Traits/getYmm'
import VehicleRequestWrapper from './VehicleRequestWrapper'

export const FetchCustomerProjects = async (
  webUserGuid,
  prevState,
  customerProjectUrl,
  selectedFacetData,
  forceRefresh = false,
) => {
  if (!forceRefresh && prevState?.customerProjects) return prevState

  const variables = {
    webUserGuid: webUserGuid,
    selectedFacetData: transformFacetDataToTraitsFormat(selectedFacetData),
  }

  return await VehicleRequestWrapper(getCustomerProjectsQuery, variables, customerProjectUrl)
}

export const FetchPartTypeLink = async (yearId, makeId, modelId, raceTypeId, partTypeId) => {
  const query = buildLinkQuery

  const variables = {
    linkRequest: {
      year: yearId,
      make: makeId,
      model: modelId,
      raceType: raceTypeId,
    },
  }

  if (partTypeId) {
    variables.linkRequest.partTypes = [partTypeId]
  }

  return await VehicleRequestWrapper(query, variables, '/graphql/trait')
}

export const FetchYearMakeModel = async (state, yearId, makeId, modelId, traitsUrl, selectedFacetData) => {
  if (state.allYears && state.allYears?.length !== 0 && !yearId) {
    return false
  }

  const query = getYmmQuery

  const variables = {
    request: {
      year: yearId,
      make: makeId,
      model: modelId,
      selectedFacetData: transformFacetDataToTraitsFormat(selectedFacetData),
    },
  }

  return await VehicleRequestWrapper(query, variables, traitsUrl)
}

export const FetchEngine = async (
  state,
  engineManufacturerId,
  engineMakeId,
  engineSeriesId,
  engineConfigurationId,
  traitsUrl,
  selectedFacetData,
  vehicleBaseId,
  raceTypeId,
) => {
  if (state.engineMakes && state.engineMakes?.length !== 0 && !engineMakeId) {
    return false
  }

  const query = getEngineDropdownQuery

  const variables = {
    request: {
      engineManufacturerId,
      engineMakeId,
      engineSeriesId,
      engineConfigurationId,
      selectedFacetData: transformFacetDataToTraitsFormat(selectedFacetData, vehicleBaseId, raceTypeId),
    },
  }
  return await VehicleRequestWrapper(query, variables, traitsUrl)
}

export const FetchRaceType = async (state, raceTypeId, traitsUrl, selectedFacetData) => {
  if (state.raceTypes && state.raceTypes?.length !== 0 && !raceTypeId) {
    return false
  }

  const query = getRaceTypeDropdownQuery
  const variables = {
    raceTypeId,
    selectedFacetData: transformFacetDataToTraitsFormat(selectedFacetData),
  }
  return await VehicleRequestWrapper(query, variables, traitsUrl)
}

export const getProperUrl = (item) => {
  if (window.location.pathname.toLowerCase().includes('search')) {
    const params = new URLSearchParams(window.location.search)
    const searchTerm = params.get('query')
    if (!searchTerm) {
      console.error("search url didn't have a search query!")
      return item.shopUrl
    }
    if (!item.searchUrl.includes('?query=')) return item.searchUrl.replace('?', `?query=${searchTerm}&`)
    else return item.searchUrl
  } else if (window.location.pathname.toLocaleLowerCase().includes('shop')) return item.shopUrl

  return item.customerProjectUrl ? item.customerProjectUrl : item.shopUrl
}

function transformFacetDataToTraitsFormat(selectedFacetData, vehicleBaseId, raceTypeId) {
  if (!selectedFacetData) {
    return selectedFacetData
  }
  if (vehicleBaseId) {
    return {
      ...selectedFacetData,
      vehicleBaseId,
      selectedFacetOptions:
        selectedFacetData?.selectedFacetOptions?.flatMap((facet) =>
          facet.searchResponseFacetOptions?.map(
            (option) =>
              ({
                valueId: option.id,
                facetType: facet.facetType,
                engineFacetType: facet.engineFacetType,
                displayText: facet.displayText,
                engineFitmentDetails: facet.engineFitmentDetails,
              }) ?? [],
          ),
        ) ?? [],
    }
  } else if (raceTypeId) {
    return {
      ...selectedFacetData,
      raceTypeId,
      selectedFacetOptions:
        selectedFacetData?.selectedFacetOptions?.flatMap((facet) =>
          facet.searchResponseFacetOptions?.map(
            (option) =>
              ({
                valueId: option.id,
                facetType: facet.facetType,
                engineFacetType: facet.engineFacetType,
                displayText: facet.displayText,
                engineFitmentDetails: facet.engineFitmentDetails,
              }) ?? [],
          ),
        ) ?? [],
    }
  }

  return {
    ...selectedFacetData,
    selectedFacetOptions:
      selectedFacetData?.selectedFacetOptions?.flatMap((facet) =>
        facet.searchResponseFacetOptions?.map(
          (option) =>
            ({
              valueId: option.id,
              facetType: facet.facetType,
              engineFacetType: facet.engineFacetType,
              displayText: facet.displayText,
              engineFitmentDetails: facet.engineFitmentDetails,
            }) ?? [],
        ),
      ) ?? [],
  }
}

export const RemoveUserVehicle = async (webUserGuid, projectId, customerProjectUrl) => {
  const query = removeProjectFromGarageQuery

  const variables = {
    projectToRemove: {
      webUserGuid: webUserGuid,
      projectId: projectId,
    },
  }

  return await VehicleRequestWrapper(query, variables, customerProjectUrl)
}

export const AddUserVehicle = async (
  webUserGuid,
  customerProjectUrl,
  yearId,
  makeId,
  modelId,
  raceTypeId,
  vehicleBaseId,
  selectedFacetData,
) => {
  const query = addNewProjectToGarageQuery

  const variables = {
    projectRequest: {
      year: yearId,
      makeId: makeId,
      modelId: modelId,
      raceTypeId: raceTypeId,
      webUserGuid: webUserGuid,
      customerProjectSource: 'CUSTOMER_ENTERED',
      vehicleBaseId: vehicleBaseId,
      selectedFacetData: transformFacetDataToTraitsFormat(selectedFacetData),
    },
  }

  return await VehicleRequestWrapper(query, variables, customerProjectUrl)
}

export const AddCustomerProject = async ({
  webUserGuid,
  customerProjectUrl,
  year,
  makeId,
  modelId,
  raceTypeId,
  vehicleBaseId,
  engineIds,
  selectedFacetData,
}) => {
  const query = addNewProjectToGarageQuery

  const variables = {
    projectRequest: {
      year,
      makeId,
      modelId,
      raceTypeId,
      engineIds,
      webUserGuid,
      customerProjectSource: 'CUSTOMER_ENTERED',
      vehicleBaseId,
      selectedFacetData: transformFacetDataToTraitsFormat(selectedFacetData),
    },
  }

  return await VehicleRequestWrapper(query, variables, customerProjectUrl)
}

export const UpdateCustomerProjectData = async ({
  webUserGuid,
  customerProjectUrl,
  year,
  makeId,
  modelId,
  raceTypeId,
  vehicleBaseId,
  engineIds,
  selectedFacetData,
  customerProjectId,
}) => {
  const query = updateCustomerProjectQuery

  const variables = {
    projectRequest: {
      year,
      makeId,
      modelId,
      raceTypeId,
      engineIds,
      webUserGuid,
      customerProjectSource: 'CUSTOMER_ENTERED',
      customerProjectId,
      vehicleBaseId,
      selectedFacetData: transformFacetDataToTraitsFormat(selectedFacetData),
    },
  }

  return await VehicleRequestWrapper(query, variables, customerProjectUrl)
}

export const FetchMakes = async (traitsUrl) => {
  const query = getAllMakesQuery

  return await VehicleRequestWrapper(query, null, traitsUrl)
}

export const FetchModels = async (makeName, traitsUrl) => {
  const query = getModelsQuery

  const variables = {
    make: makeName,
  }

  return await VehicleRequestWrapper(query, variables, traitsUrl)
}
